import { render, staticRenderFns } from "./InqCertM.vue?vue&type=template&id=2c78a171&scoped=true"
import script from "./InqCertM.vue?vue&type=script&lang=js"
export * from "./InqCertM.vue?vue&type=script&lang=js"
import style0 from "./InqCertM.vue?vue&type=style&index=0&id=2c78a171&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c78a171",
  null
  
)

export default component.exports